import { useEffect, useState } from 'react'

export default function useHeight() {
    var viewportWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    )
    var screenWidth = window.screen.width
    var viewportScale = screenWidth / viewportWidth

    const [height, setHeight] = useState(
        window.innerHeight * (viewportScale || 1)
    )

    useEffect(() => {
        const onResize = () => {
            setHeight(window.innerHeight * (viewportScale || 1))
        }

        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
        }
    })

    return height + 'px'
}
